// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PJ2an","svg":"styles_svg__vVgbA","arm":"styles_arm__DOn5B","wave":"styles_wave__2DjpX"};